// Mission/Vision copy (ZP-10) and shared company-profile text, kept as data
// so both the About page and the PDF brochure (ZP-98) read from one source.

// Word counts kept under 40 per ZP-10's AC.
export const MISSION =
  "To put fresher, fairer seafood on every Indian table by shortening the chain between fisherman and kitchen to just one link.";

export const VISION =
  "A coastal economy where fishing families thrive and consumers trust exactly where their seafood came from.";

export const FOUNDER_STORY_CAPTION =
  "Started by two friends who couldn't watch another fishing family get squeezed by middlemen.";
